const actions = {
    GET_CLIENT_EMPLOYEE_DOCUMENTS: 'clientEmployeeDocuments/GET_CLIENT_EMPLOYEE_DOCUMENTS',
    SET_CLIENT_EMPLOYEE_DOCUMENTS: 'clientEmployeeDocuments/SET_CLIENT_EMPLOYEE_DOCUMENTS',

    GET_CLIENT_EMPLOYEE_DOCUMENT: 'clientEmployeeDocument/GET_CLIENT_EMPLOYEE_DOCUMENT',
    SET_CLIENT_EMPLOYEE_DOCUMENT: 'clientEmployeeDocument/SET_CLIENT_EMPLOYEE_DOCUMENT',
};
export default actions;